import { render, staticRenderFns } from "./MyTraceInput.vue?vue&type=template&id=08266274&scoped=true"
import script from "./MyTraceInput.vue?vue&type=script&lang=js"
export * from "./MyTraceInput.vue?vue&type=script&lang=js"
import style0 from "./MyTraceInput.vue?vue&type=style&index=0&id=08266274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08266274",
  null
  
)

export default component.exports